import { BACKEND_URL } from '../constants';
export default function authenticatedFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const url = new URL(typeof input === 'string' ? input : input instanceof URL ? input.href : input.url, window.location.origin);
  const backendOrigin = new URL(BACKEND_URL || '/', window.location.origin).origin;
  const headers = new Headers(init?.headers || (input instanceof Request ? input.headers : undefined));
  const token = localStorage.getItem('token');
  if (token && url.pathname.startsWith('/v1/api/') && (url.origin === window.location.origin || url.origin === backendOrigin)) headers.set('Authorization', 'Bearer ' + token);
  return window.fetch(input, { ...init, headers });
}
